// components/BulkImportCustomers/BulkImportCustomersLink.jsx
import React from "react";
import { Tooltip, IconButton } from "@material-ui/core";
import { CloudUpload as CloudUploadIcon } from "components/MaterialSymbol/MaterialIcons";
import { useConfirmationDialog } from "hooks/useConfirmationDialog";
import BulkCustomerUploadModal from "./BulkCustomerUploadModal";

export default function BulkImportCustomersLink({ dealerId }) {
    const { openDialog, closeDialog } = useConfirmationDialog();

    const disabled = !dealerId;

    const openModal = () => {
        if (disabled) return;
        openDialog({
            customDialog: true,
            fullWidth: true,
            maxWidth: "xs",
            message: <BulkCustomerUploadModal dealerId={dealerId} onClose={closeDialog} />,
        });
    };

    return (
        <Tooltip
            title={disabled ? "Select a dealer to import customers" : "Bulk Import Customers"}
            placement="top"
        >
            <span>
                <IconButton
                    color="primary"
                    size="small"
                    onClick={openModal}
                    disabled={disabled}
                    aria-label="Bulk Import Customers"
                >
                    <CloudUploadIcon fontSize="small" />
                </IconButton>
            </span>
        </Tooltip>
    );
}
